import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";

import CustomCheckbox from "./CustomCheckbox";
import PlytixProductList from "./PlytixProductList";
import AkeneoChannelPicker from "./AkeneoChannelPicker";
import AkeneoLocalePicker from "./AkeneoLocalePicker";
import AkeneoFamilyPicker from "./AkeneoFamilyPicker";

export default function IntegrationsOptionsRenderer({ conf, launch, setConf, isAdmin, auth }) {

    // mappare nome del componente --> componente da renderizzare, per ogni integration option disponibile
    const INTEGRATIONS_OPTIONS_MAP = {
        // Plytix
        "PlytixProductList": <PlytixProductList />,

        // Akeneo
        "AkeneoChannelPicker": <AkeneoChannelPicker />,
        "AkeneoLocalePicker": <AkeneoLocalePicker />,
        "AkeneoFamilyPicker": <AkeneoFamilyPicker />,

        // General
        "Checkbok": <CustomCheckbox />
    }


    // per ogni opzione renderizzo il componente indicato e passo i parametri del componente come props
    // Nota: default è una keyword riservata in JS, quindi nella conf va rinominata (es. default --> defaultValue)
    // Quindi attenzione a non inserire come atributi nella conf delle keyword JS riservate
    return (
        <Box>
            {Object.entries(conf.integrationsOptions ?? {}).map(([key, options]) => (
                <React.Fragment key={key}>
                    <Typography variant="h2" fontSize={20} fontWeight={600}>{key}</Typography>
                    {options.map((option, i) => (
                        <React.Fragment key={`${key}-${i}`}>
                            {INTEGRATIONS_OPTIONS_MAP[option.component]
                                ? React.cloneElement(INTEGRATIONS_OPTIONS_MAP[option.component], { conf, setConf, groupKey: key, i })
                                : null}
                        </React.Fragment>
                    ))}
                </React.Fragment>
            ))}
        </Box>
    )
}